export enum AuthEndpoints {
  GET = 'auth/',
}

export enum UserEndpoints {
  USERS = 'users/',
  TIERS = 'users/tiers',
  TIERS_TREE = 'users/tiers-tree',
  UPDATE_ROLES = 'users/roles-permissions',
}

export enum NodeTypeEndpoints {
  GET_ALL = 'node-types',
}

export enum PlaybookEndpoints {
  GET_ALL = 'playbooks',
  GET_ONE = 'playbooks/',
  UPDATE = 'playbooks/',
  CREATE = 'playbooks/',
  DELETE = 'playbooks/',
  RUN = 'playbooks/:id/runs',
  STOP = 'playbooks/:id/runs',
  DOWNLOAD_PDF = 'playbooks/pdf/download',
  EXPORT_YAML = 'playbooks/:id/export',
  IMPORT_YAML = 'playbooks/import',
  GET_REPORT = 'v1/playbooks/:id/reports/:report',
  START_PLAYBOOK = 'v1/playbooks/:id/start',
}

export enum NodeEndpoints {
  CREATE = 'nodes',
  UPDATE = 'nodes/',
}

export enum SchedulerEndpoints {
  GET = 'schedulers/',
  CREATE = 'schedulers/',
  UPDATE = 'schedulers/',
  DELETE = 'schedulers/',
}

export enum FrequencyAssignmentEndpoints {
  GET = '/spectrum-manager/frequency-assignments',
}

export enum RequestFormEndpoints {
  GET_DEVICES = 'request-form/devices',
  GET_EXERCISES = 'request-form/exercises',
  STATION_CLASS = 'request-form/station-classes',
  EMISSION_TYPES = 'request-form/emission-types',
  GET_USAGE_TIMES = 'request-form/usage-time',
  REQUEST = 'request-form/request',
  GET_STATE_REGIONS = 'request-form/state-regions',
  GET_NOMENCLATURES = 'request-form/nomenclatures',
  GET_DEVICE_ANTENNAS = 'request-form/device-antennas',
  GET_OPERATING_UNITS = 'request-form/operating-units',
  GET_MAJOR_FUNCTIONS = 'request-form/major-functions',
  GET_REQUESTS = 'request-form/requests',
  GET_NUMBER_OF_STATIONS = 'request-form/number-of-stations',
  GET_LOCATION_TEMPLATES = 'request-form/location-templates',
  GET_USAGE_TIME_SERVICES = 'request-form/usage-time-service',
  GET_OPERATING_SUB_UNITS = 'request-form/operating-sub-units',
  GET_FREQUENCY_TEMPLATES = 'request-form/frequency-templates',
  REQUEST_DEVICE = 'request-form/request-device',
  GET_PLATFORMS = 'request-form/platforms',
  GET_LOCATION_TEMPLATES_WITH_REGIONS = 'request-form/location-templates-with-regions',
  GET_FREQUENCY_PLANS = 'request-form/frequency-plans',
  GET_REQUEST_FREQUENCIES = 'request-form/request-frequency-groups',
  GET_CLASSIFICATION_TYPES = 'request-form/classification-types',
  STATION_CLASS_DESCRIPTION = 'request-form/station-class-descriptions',
  GET_RADAR_TUNABILITY_TYPES = 'request-form/radar-tunability-types',
  GET_INTERMEDIATE_FUNCTIONS = 'request-form/intermediate-functions',
  REQUEST_LOCATIONS = 'request-form/request-location',
  REQUEST_EQUIPMENTS = 'request-form/request-equipment',
  REQUEST_STATION_CLASS = 'request-form/request-station-class',
  REQUEST_DEVICE_ANTENNA = 'request-form/request-device-antenna',
  EMISSION_DESIGNATOR_SIMPLE_TYPES = 'request-form/emission-designator-simple-types',
  REQUEST_FREQUENCY_GROUPS = 'request-form/request-frequency-group',
  REQUEST_FREQUENCY_EXCLUSIONS = 'request-form/request-frequency-exclusion',
  GET_DEVICE_TRANSMITTERS = 'request-form/device-transmitters',
}

export enum TierEndpoints {
  GET_ALL = 'tiers',
}

export enum HeatmapEndpoints {
  ANALYZE_POINTS = '/rf-model/analyze',
  CREATE_HEATMAP = '/rf-model/heatmap',
  CREATE_CUSTOM_HEATMAP = '/rf-model/simulate',
}

export enum SpectrumManagerEndpoints {
  SFAF = '/spectrum-manager/sfaf',
  DEVICE = '/spectrum-manager/device',
  HOPSET = '/spectrum-manager/hopsets',
  LICENSE = '/spectrum-manager/licenses',
  EXERCISE = '/spectrum-manager/exercise',
  PLATFORMS = '/spectrum-manager/platform',
  FREQUENCY = '/spectrum-manager/frequency',
  EQUIPMENT = '/spectrum-manager/equipment',
  SFAF_ANTENNAS = '/spectrum-manager/sfaf-antennas',
  SFAF_CONTENTS = '/spectrum-manager/sfaf-contents',
  DEVICE_ANTENNA = '/spectrum-manager/device-antennas',
  SFAF_EQUIPMENTS = '/spectrum-manager/sfaf-equipments',
  FREQUENCY_PLANS = '/spectrum-manager/frequency-plans',
  SFAF_FREQUENCIES = '/spectrum-manager/sfaf-frequencies',
  FREQUENCY_GROUPS = '/spectrum-manager/frequency-group',
  AGENCY_OVERRIDE = '/spectrum-manager/agency-override',
  FREQUENCY_REQUEST = '/spectrum-manager/frequency-request',
  REQUESTS = '/spectrum-manager/request',
  ARC_DIAGRAM_NODES = 'spectrum-manager/arc-diagram-nodes',
  DEVICE_TRANSMITTER = '/spectrum-manager/device-transmitters',
  LOCATION_TEMPLATES = '/spectrum-manager/location-template',
  NOMINATE_FREQUENCY = '/spectrum-manager/nominate-frequency',
  DEVICE_ANTENNA_MODE = '/spectrum-manager/device-antenna-mode',
  SFAF_STATION_CLASSES = '/spectrum-manager/sfaf-station-classes',
  OPEN_FREQUENCY_REQUEST = '/spectrum-manager/open-frequency-requests',
  FREQUENCY_POOL_EQUIPMENT = '/spectrum-manager/frequency-pool-equipment',
  DEVICE_TRANSMITTER_PULSE = '/spectrum-manager/device-transmitter-pulse',
  SFAF_EXCLUDED_FREQUENCIES = '/spectrum-manager/sfaf-excluded-frequencies',
  FREQUENCY_POOL_113_114_115 = '/spectrum-manager/frequency-pool-113-114-115',
}
